import styled from "styled-components";

export const WebseriesWrapper = styled.div`
  margin-top:50px;
   margin-bottom:50px;
  h1 {
    margin-bottom: 8px;
    font-size: 28px;
    font-weight: 700;
    line-height: 30.8px;
  }
`;

export const WeseriesCard = styled.div`
   padding:0px 5px;
   margin-top:10px;
 
 
  img {
    align-items:center;
    height:210px;
    object-fit: cover;
    object-position:center;
    width:100%;
    border-radius: 4px;
  
  }

`;

export const PackageWrapper=styled.h5`
   color:rgb(53,147,145);
   font-size:14px;
   margin-top:5px;
   font-weight:bold;
`

export const TitleWrapper=styled.h4`
   font-weight:700;
   font-size:18px;
   letter-spacing:0.6px;
`

export const LoactionWrapper=styled.div`
   display:flex;
   justify-content: space-between;
   color:rgb(53,147,145);
   margin-top:5px;
`
export const LogoWrapper=styled.div`
  display:flex;

`
export const DaybuttonWrapper=styled.button`
  color:white;
  background-color: rgb(53,147,145);
  border-radius:13px;
  padding:3px 8px;
  font-size:13px;
`

export const LogoImage=styled.div`
display:flex;
align-items: center;
margin-top:10px;
  img{
    width:30px;
    height:30px;
    border-radius: 50%;
  }
  h3{
    padding-left:5px;
    font-size:14px;
  }
`

export const PriceWrapper=styled.div`
  display:flex;
  justify-content: space-between;
  margin-top:15px;
  margin-bottom:10px;
`

export const PersonWrapper=styled.div`
  display:flex;
  h3{
    font-weight:bold;
    font-size:18px;
  }
  h6{
    margin-left:4px;
  }
`
export const Getquotes=styled.button`
   border:1px solid rgb(53,147,145);
   border-radius:6px;
   color:rgb(53,147,145);
   padding:3px 7px;
   font-size:16px;
`
